module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./error-404-page.ts"));
	}, "views/error-404-page/error-404-page");
}